import type { ComponentPropsWithoutRef, ReactNode } from 'react';

type ContainerProps = {
  children: ReactNode;
  size?: 'default' | 'narrow' | 'wide';
} & ComponentPropsWithoutRef<'div'>;

export function Container({
  children,
  className = '',
  size = 'default',
  ...props
}: ContainerProps) {
  return (
    <div className={`container container--${size} ${className}`.trim()} {...props}>
      {children}
    </div>
  );
}
